import { Store } from 'vuex'
import { Router } from 'vue-router'
import { State as StoreState } from '@/store/index'
import { useUserAuth } from '@/model/api/user/apiUserAuthinfo'
import { useStoreAction } from '@/model/store/store'
import * as StateType from '@/store/state'
import * as RouterTypeData from '@/model/router/routerType'
import { useScreen } from '@/model/screen/screenTransition'

/**
 * ユーザー認証の有無を判定する
 * @param store vuex
 * @returns true: ユーザー認証済み, false:ユーザー認証未認証
 */
const check = (store: Store<StoreState>) => store.getters.authinfocheck

/**
 * ユーザー認証取得処理を実施する
 * @param store vuex
 * @param router vue router
 * @param input TOP画面遷移入力情報
 * @returns true: 認証有り, false: 未認証
 */
const setAuth = async (
  store: Store<StoreState>,
  router: Router,
  input: RouterTypeData.LoginTopData
): Promise<boolean> => {
  if (!check(store)) {
    // api送信
    const { normaldata } = await useUserAuth(store).get()
    if (normaldata !== undefined) {
      // 認証情報正常の場合はvuexに設定する
      const data: StateType.Login = {
        status: true,
        username: normaldata.username,
        usernamedisp: normaldata.usernamedisp,
        csrftoken: normaldata.csrftoken,
      }
      // 認証情報設定
      // 認証正常のためtrueを返す
      await useStoreAction(store).loginAuthinfo(data)
      return true
    }
    // 認証無しの場合はTOP画面に遷移して、falseを返す。認証切れのエラーメッセージは表示しない
    useScreen().topRedirectNormal(store, router, input)

    return false
  }
  // 認証済みの場合は、何もしないでtrueを返す
  return true
}

export { check, setAuth }
